'use client'

import React, { createContext, useContext } from 'react'
import { useUserContext } from '@/providers/UserProvider'

interface NotificationContextValue {
  isPollingActive: boolean
  refresh: () => Promise<void>
}

const NotificationContext = createContext<NotificationContextValue>({
  isPollingActive: false,
  refresh: async () => {}
})

interface NotificationProviderProps {
  children: React.ReactNode
}

/**
 * Minimal NotificationProvider stub kept for compatibility.
 * Polling is now handled locally in components that need it.
 */
export function NotificationProvider({ children }: NotificationProviderProps) {
  const { user } = useUserContext()

  const contextValue: NotificationContextValue = {
    isPollingActive: !!user,
    refresh: async () => {}
  }

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  )
}

export function useGlobalPolling() {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useGlobalPolling must be used within NotificationProvider')
  }
  return context
}
